import { Component, Input, OnInit } from '@angular/core';

import { CompanyService } from '../service/company.service';

@Component({
  selector: 'app-printheader',
  templateUrl: './printheader.component.html',
  styleUrls: ['./printheader.component.css'],
})
export class PrintheaderComponent implements OnInit {
  constructor(private companyService: CompanyService) {
    this.companyId = localStorage.getItem('companyId');
    this.getCompanyData();
  }

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() projectName: string;

  @Input() pageName: string;

  @Input() diffHeaderInvestor: boolean;

  @Input() diffHeaderAppraisal: boolean;

  // DECLARATION OF ALL VARIABLES
  companyLogoUrl: '';

  companyId: string;

  ngOnInit() {}

  // GET COMPANY LOGO FROM COMPANY TABLE(DB)
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/printheader/printheader.component.ts